







import Vue from 'vue';
import {Component} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiToolbar from "../common/AsiToolbar.vue";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import PlanningEntryList from "@/components/planningEntry/PlanningEntryList.vue";
import PlanningEntryListFilter from "@/models/planningEntry/PlanningEntryListFilter";
import {toISODateString} from "@/helpers/functions_asi";

@Component({
	components: {PlanningEntryList, AsiContentContainer, AsiToolbar}
})
export default class OfficePendingReports extends Vue {

	private icons = Icon;
	private planningEntryFilterModel: PlanningEntryListFilter | null = null;

	public created(): void {
		this.planningEntryFilterModel = new PlanningEntryListFilter();
		this.planningEntryFilterModel.hasReports = false;
		this.planningEntryFilterModel.dateTo = toISODateString(new Date());
	}

}
